/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import CampaignCards from './campaignCards'
import DownloadCards from './downloadCards'
import useStyles from 'src/styles/pages/campaign'
import HeaderMatrix from './headerMatrix/Content'
import Collabrations from './Collabration/Collabrations'
import BrandsCollab from 'src/components/shared/modules/brandsCollab'
import { Box } from '@mui/system'
import { contentType } from 'src/types/components/shared/atom'
import HeroHeader from 'src/components/pages/campaign/heroHeader/HeroHeader'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
import { campaignHeroCard } from 'src/types/components/shared/atom/index'
import ImgAvatar from 'src/assets/images/campaigns/avatarHeader.png'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import { useGetCampaignPartnerApiQuery } from 'src/store/ApiCall/getCampaignPartners'
import HeadTag from 'src/components/layout/head'
import { useRouter } from 'next/router'
import {
  campaignCardsI,
  campaignsBrandGuidlinesCardI,
  ContactFormI,
  HeadingTextButton,
  RecentPressI,
} from 'src/types/store/index'
import Skeleton from 'src/components/shared/modules/skeleton'

interface IProps {
  data?: any
  isLoading?: boolean
}
function Campaign({ data, isLoading }: IProps) {
  const { classes } = useStyles()
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  // const { data, isLoading } = useGetPageByNameQuery('campaigns')
  const { data: campaignPartnerData } = useGetCampaignPartnerApiQuery()
  const router = useRouter()
  const [header, setHeader] = useState<contentType>()

  const [campaignCards, setCampaignCards] = useState<campaignCardsI[]>()
  const [campaignPartner, setCampaignPartner] = useState<RecentPressI[]>()
  const [campaignHeader, setCampaignHeader] = useState<HeadingTextButton>()
  const [formData, setFormData] = useState<ContactFormI>()
  const [campaignsBrandGuidlinesCard, setcampaignsBrandGuidlinesCard] =
    useState<campaignsBrandGuidlinesCardI[]>()

  useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const {
        heroHeader,
        campaignsCard,
        campaignsBrandGuidelines,
        campaignVideoList,
        contactForm,
      } = content

      if (heroHeader) {
        const { primaryText, secondaryText, tertiaryText } = heroHeader
        const headerText: contentType = {
          content: {
            secondary: {
              content: secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },

          button: heroHeader.button ? [heroHeader.button] : [],
        }

        setHeader(headerText)
      }
      if (campaignsCard) {
        setCampaignCards(campaignsCard)
      }
      if (campaignsBrandGuidelines) {
        setcampaignsBrandGuidlinesCard(campaignsBrandGuidelines)
      }
      if (campaignVideoList) setCampaignHeader(campaignVideoList)

      if (contactForm) setFormData(contactForm)
    } else if (data && data.data.length == 0 && !isLoading) {
      router.push('/404')
    }

    if (campaignPartnerData && campaignPartnerData.data.length > 0) {
      setCampaignPartner(campaignPartnerData.data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, campaignPartnerData])

  const [heroHeaderCard] = React.useState<campaignHeroCard>({
    heading: 'Love not labels',
    date: 'MARCH 20, 2022',
    brandName: 'River Island',
    brandAvatar: ImgAvatar,
    link: '#',
    button: {
      content: 'LATEST',
      href: '#',
    },
  })

  return (
    <>
      <HeadTag
        title={data?.data[0]?.attributes.metaTitle}
        description={data?.data[0]?.attributes.metaDescription}
      />
      <div>
        {header ? (
          <HeroHeader
            zenMode={zenMode}
            endAdornment={false}
            placeHolder="Search videos..."
            content={header}
            homeIcon={false}
          />
        ) : (
          <Skeleton />
        )}
        {heroHeaderCard && campaignPartner ? (
          <HeaderMatrix
            zenMode={zenMode}
            heroHeaderCard={heroHeaderCard}
            campaignPartner={campaignPartner}
          />
        ) : (
          ''
        )}

        <div className={classes.outerContainer}>
          <div className={classes.campaignsContainer}>
            {campaignHeader ? (
              <Box py={13}>
                <BrandsCollab headerContent={campaignHeader} />
              </Box>
            ) : (
              ''
            )}

            {campaignCards ? (
              <CampaignCards zenMode={zenMode} cardsData={campaignCards} />
            ) : (
              ''
            )}
            {formData ? <Collabrations content={formData} /> : ''}

            {campaignsBrandGuidlinesCard ? (
              <DownloadCards
                zenMode={zenMode}
                campaignsBrandGuidlinesCard={campaignsBrandGuidlinesCard}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  )
}

// This gets called on every request

export default Campaign
